import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { AuthService } from 'app/auth/auth.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { PatientDetailModel } from 'app/opdvisits/Models/patient_details.model';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { ReportserviceService } from 'app/reports/reportservice.service';
import { ExportService } from 'app/reports/services/export.service';

@Component({
  selector: 'app-patient-category-wise-report',
  templateUrl: './patient-category-wise-report.component.html',
  styleUrls: ['./patient-category-wise-report.component.scss']
})
export class PatientCategoryWiseReportComponent implements OnInit {
  public link: string = 'https://www.clickdimensions.com/links/TestPDFfile.pdf';
  fileName= 'ExcelSheet.xlsx';  
  showspinner = false;
  patientcount;
  dataSource = new MatTableDataSource<PatientDetailModel>();
  startdate;
  enddate;
  pname = "";
  flag=1;
  pageHeading:any;
  isShowDivIf:boolean = false;
  constructor( public opdvisitService: OpdVisitService,
    public datepipe: DatePipe,public authService :AuthService,
    public dashboardService: DashboardService,private exportdata:ExportService,public reportService:ReportserviceService) { 
     
    }
    displayedColumns: string[] = ['Patientid', 'Regdate', 'First_name', 'Last_name',
    'emailAddress','categoryname','paddress','gender','oldMrno',
   'dob','mobno'];
  ngOnInit(): void {
    // this.dataSource.data = this.reportService.patients;
    // this.patientcount = this.reportService.patients.length;
    this.pageHeading = 'Patient Register Category Wise';
  }
  toggleDisplayDivIf() {
    this.isShowDivIf = !this.isShowDivIf;
  }
  gettop_200byname(pname: string){
    if(pname){
      this.showspinner = true;
      this.dataSource.data = [];
      var currentdate = this.authService.getServerDate;
      var lastmonth=new Date().setDate(currentdate.getDate() - 30);
      let sdate = this.datepipe.transform(lastmonth, "yyyy-MM-dd");
      let edate = this.datepipe.transform(currentdate, "yyyy-MM-dd");
      this.reportService.get_CategoryName_data_sdate_edate(sdate,edate,pname).subscribe(
        data => this.successtop200(data), err => this.failedtop200(err)
      )
} 
else{
  this.dashboardService.openSnackBar("Please Enter Category", "Ok");
}

  
  }
  successtop200(data){
    this.showspinner = false;
    this.reportService.patients = [];
    this.reportService.patients = data;
    this.dataSource.data = this.reportService.patients;
   this.patientcount = this.reportService.patients.length;
   // alert("api working");
  }

  failedtop200(err){
    // alert("api failed");
    this.patientcount =0;
  }

  get_records_between_two_dates(){

   
    this.showspinner = true;
    this.dataSource.data = [];
   // this.dashboardService.selecteddate = this.datePipe.transform(selecteddate, "yyyy-MM-dd");
    let sdate = this.datepipe.transform(this.startdate, "yyyy-MM-dd");
    let edate = this.datepipe.transform(this.enddate, "yyyy-MM-dd");
    let CATEGORYid=Number(this.flag);
   this.reportService.get_Category_data_sdate_edate(sdate,edate,CATEGORYid).
   subscribe(data => this.success_pat_sdate_edate(data), err => this.failed_pat_sdate_edate(err));
 }

 success_pat_sdate_edate(data){
  
 this.showspinner = false;
 this.reportService.patients = [];
 this.reportService.patients = data;
 this.dataSource.data = this.reportService.patients;
this.patientcount = this.reportService.patients.length;
 }
failed_pat_sdate_edate(err){
this.showspinner = false;
this.patientcount =0;
}



selectpatient(selectedpatient: PatientDetailModel){

this.opdvisitService.getpatientdetails(selectedpatient.pkRegId);
//this.opdvisitService.patientdetails = selectedpatient;

}

exportexcel(): void 
    {
       let element = document.getElementById('content'); 
       this.exportdata.exportxcel(element);
     }

 
  public openPDF():void {
    let DATA = document.getElementById('content');
    this.exportdata.download(DATA);
        
  }
  
  printComponent(cmpName) {
    let printContents = document.getElementById(cmpName).innerHTML;
    this.exportdata.printData(printContents);
    
}
}
